import { OverlayTabLayout } from '../OverlayTabLayout';
import { ActivityOverTime } from './ActivityOverTime';
import { SessionsBreakdownCard } from './SessionsBreakdownCard';

export const ActivitiesTab = () => {
  return (
    <OverlayTabLayout>
      <div className="flex flex-col gap-6">
        <div className="h-[300px]">
          <ActivityOverTime />
        </div>
        <div className="pb-10">
          <SessionsBreakdownCard />
        </div>
      </div>
    </OverlayTabLayout>
  );
};
